module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAaCAYAAABLlle3AAAABGdBTUEAALGPC/xhBQAAALpJREFUSA1j/P///1YGBgYvIKYX2MYItPQ/vWyD2cMEY9CTHrWUpqE9Gryjwcvw99dnikOB6IT0/+9PhienOhje3weVmpQBoopBkIUPj9aBbeKXscVpo6CSD045ZAkWZA5eNiMjAwsbP14lxEoS5VOQYSDfPj03gYGDV55BRCOCWPOxqiPaUphuUEJiZuOFccmiSbaULFvQNBGdetH0UcQdtZSi4COkeTR4CYUQRfIDFrzbKHI26Zq3AgBA5DPty4qChAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/button_l1.png
// module id = uWOf
// module chunks = 1